module.exports = __webpack_public_path__ + "img/LimaconPascal_gmt.29ae523d.gif";